import type { SessionConfig } from '@xing-com/crate-xinglet/internal';

import type { FetchFunction, FetchImpl } from '../types';

export function configureFetchWithAcceptLanguageHeader(
  { fetch, Request }: FetchImpl,
  sessionConfig: SessionConfig
): FetchFunction {
  return (...args) => {
    const { language } = sessionConfig;
    const request = new Request(...args);
    request.headers.set('Accept-Language', language);

    return fetch(request);
  };
}
